import { render, staticRenderFns } from "./AddNewGame.vue?vue&type=template&id=0e21eda4"
import script from "./AddNewGame.vue?vue&type=script&lang=js"
export * from "./AddNewGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports